import ParsedDecoratorChildren from "../components/ParsedDecoratorChildren";
import { REGEX_BI } from "../regex";
import { jsx as _jsx } from "react/jsx-runtime";
var BoldItalic = function BoldItalic(_ref) {
  var offsetKey = _ref.offsetKey,
    decoratedText = _ref.decoratedText,
    isDark = _ref.isDark;
  var text = decoratedText.match(REGEX_BI) ? decoratedText.substring(2, decoratedText.length - 2) : decoratedText;
  return /*#__PURE__*/_jsx("strong", {
    className: "tw-font-semibold italic",
    "data-offset-key": offsetKey,
    children: /*#__PURE__*/_jsx(ParsedDecoratorChildren, {
      text: text,
      isDark: isDark
    })
  });
};
export default BoldItalic;